/**
 * Constants for UnifiedParsingModal
 */

// Step names as const array for type safety
export const STEP_NAMES = ['method', 'config', 'parsing', 'results', 'ai_analysis', 'editing', 'confirm', 'upload_results'] as const
export type StepName = typeof STEP_NAMES[number]

// Step indices for easy reference
export const STEP_INDEX = {
  method: 0,
  config: 1,
  parsing: 2,
  results: 3,
  ai_analysis: 4,
  editing: 5,
  confirm: 6,
  upload_results: 7,
} as const

// Batch size for VDL upload (to avoid timeouts)
export const UPLOAD_BATCH_SIZE = 50

// Region name helper (using WordCraft regional IDs!)
export const REGION_NAMES: Record<string, string> = {
  '225': 'Россия',
  '1': 'Москва и МО',
  '10174': 'СПб и ЛО',
  '11162': 'Екатеринбург и СО',
  '11316': 'Новосибирск и НСО',
  '11029': 'Ростов-на-Дону и РО',
  '10995': 'Краснодарский край',
  '11079': 'Нижегородская область',
  '11131': 'Самарская область',
  '11069': 'Ставропольский край',
  '11266': 'Иркутская область',
  '11095': 'Пензенская область',
  '977': 'Республика Крым',
  '149': 'Беларусь',
  '142': 'Донецк и ДНР',
  '11176': 'Тюменская область',
}

export const getRegionName = (code: string): string => {
  return REGION_NAMES[code] || `Регион ${code}`
}

// Status translations
export const STATUS_TRANSLATIONS: Record<string, string> = {
  'pending': 'Ожидание',
  'running': 'Выполняется',
  'completed': 'Завершен',
  'failed': 'Ошибка'
}

// Polling configuration
export const POLLING_CONFIG = {
  maxAttempts: 120,
  intervalMs: 5000,
  batchIntervalMs: 3000,
}
